/* eslint-disable @typescript-eslint/no-explicit-any */
import { lazy } from 'react'
import SearchBlock from '~/components/Content/SearchBlock/SearchBlock'

// Assets
import ImageBlock from '~/components/Media/Core/Images/ImageBlock/ImageBlock'
import { default as ImageBlockAG } from '~/components/Media/AvantGarde/Images/ImageBlock/ImageBlock'

// Content
// import Canvas from '~/components/Canvas'
const Canvas = lazy(() => import('~/components/Canvas'))
import BlockQuote from '~/components/Content/BlockQuote/BlockQuote'
import StandardText from '~/components/Text/StandardText/StandardText'
import TextBlock from '~/components/Content/TextBlock/Core/TextBlock'
import { default as TextBlockAG } from '~/components/Content/TextBlock/AvantGarde/TextBlock'
import ImageTextBlock from '~/components/Content/ImageTextBlock/Core/ImageTextBlock'
import { default as ImageTextBlockAG } from '~/components/Content/ImageTextBlock/AvantGarde/ImageTextBlock'
import ImageTextOverlay from '~/components/Content/ImageTextOverlay/ImageTextOverlay'
import GeneralAccordion from '~/components/Content/Accordion/GeneralAccordion'
import Faqs from '~/components/Content/Faqs/Faqs'
const Tables = lazy(() => import('~/components/Content/Tables/Tables'))
import TertiaryLinkBlock from '~/components/Content/TertiaryLinkBlock/TertiaryLinkBlock'
import FeatureList from '~/components/Content/FeatureList/FeatureList'
import LargeStatistic from '~/components/Content/LargeStatistic/LargeStatistic'
import Logos from '~/components/Content/Logos/Logos'
import NewsEvents from '~/components/Content/NewsEvents/NewsEvents'

// Cards
import IconCard from '~/components/Cards/IconCard/IconCard'
import LinkCard from '~/components/Cards/LinkCard/LinkCard'
import TextCard from '~/components/Cards/TextCard/TextCard'
import ImageCard from '~/components/Cards/ImageCard/ImageCard'
import EventCard from '~/components/Cards/NewsEvents/EventCard/EventCard'
import QuoteCard from '~/components/Cards/QuoteCard/QuoteCard'
import StatisticCard from '~/components/Cards/StatisticCard/StatisticCard'
import SingleContactCard from '~/components/Cards/ContactCard/Single/SingleContactCard'
import MultiContactCard from '~/components/Cards/ContactCard/Multi/MultiContactCard'
import ProfileCard from '~/components/Cards/ProfileCard/ProfileCard'
import CourseCard from '~/components/Cards/Study/CourseCard/CourseCard'
import NewsCard from '~/components/Cards/NewsEvents/NewsCard/NewsCard'

// Media
import ImageGallery from '~/components/Media/Core/Images/ImageGallery/ImageGallery'
import VideoLauncher from '~/components/Media/Core/Video/VideoLauncher/VideoLauncher'

// Carousels
import StandardCarousel from '~/components/Carousels/Core/Standard/StandardCarousel'
import ContainedCarousel from '~/components/Carousels/Core/Contained/ContainedCarousel'
import TimelineCarousel from '~/components/Carousels/Core/Timeline/TimelineCarousel/TimelineCarousel'

const componentMapAG: { [key: string]: any } = {
  assetImage: ImageBlockAG,
  contentTextBlock: TextBlockAG,
  contentImageTextBlock: ImageTextBlockAG
}

const componentMap = {
  contentSearchBlock: SearchBlock,

  assetImage: ImageBlock,

  textCanvas: Canvas,
  textPullQuote: BlockQuote,
  textStandardCT: StandardText,
  contentTextBlock: TextBlock,
  contentImageTextBlock: ImageTextBlock,
  contentImageTextOverlayBlock: ImageTextOverlay,
  contentAccordions: GeneralAccordion,
  contentFAQ: Faqs,
  contentTables: Tables,
  contentTertiaryLinkBlock: TertiaryLinkBlock,
  contentFeatureList: FeatureList,
  contentLargeStatistic: LargeStatistic,
  contentLogos: Logos,
  contentNewsEvents: NewsEvents,

  cardIcon: IconCard,
  cardLink: LinkCard,
  cardText: TextCard,
  cardImage: ImageCard,
  cardEvent: EventCard,
  cardQuote: QuoteCard,
  cardStatistic: StatisticCard,
  cardContactSingle: SingleContactCard,
  cardContactMulti: MultiContactCard,
  cardProfile: ProfileCard,
  cardStudyCourse: CourseCard,
  pageCaseStudyResearch: NewsCard,

  mediaImageGallery: ImageGallery,
  mediaVideoLauncher: VideoLauncher,

  carouselStandard: StandardCarousel,
  carouselContained: ContainedCarousel,
  carouselTimeline: TimelineCarousel
} as any

export function loadComponent(cmsComponentName: string, avantGarde: boolean) {
  // Uses the list of Layout names above and matches it to the correct Layout
  if (avantGarde)
    return componentMapAG[cmsComponentName] || componentMap[cmsComponentName]
  return componentMap[cmsComponentName]
}
